import { Component, Output, EventEmitter, Input } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "myqq-account-setup-failed",
  templateUrl: "./account-setup-failed.component.html",
  styleUrls: ["./account-setup-failed.component.scss"],
})
export class AccountSetupFailedComponent {
  @Input() message =
    "Unfortunately, we could not locate your account with the information you provided";
  @Input() buttonText = "Try Again";
  @Output() restart = new EventEmitter();

  supportNumber = environment.supportNumber;
  supportEmail = environment.supportEmail;
  cdnHost = environment.cdnHost;

  startOver() {
    this.restart.emit();
  }
}
